import { render, staticRenderFns } from "./SingleNpi.vue?vue&type=template&id=c1f6371a&"
import script from "./SingleNpi.vue?vue&type=script&lang=js&"
export * from "./SingleNpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports